import { ColumnState } from 'ag-grid-community';
import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

interface ReconciliationFilterState {
  statusFilter: string[];
  setStatusFilter: (status: string[]) => void;
  preparerFilter: string[];
  setPreparerFilter: (preparer: string[]) => void;
  selectedEntityId: string;
  setSelectedEntityId: (entityId: string) => void;
  columnState: ColumnState[];
  setColumnState: (order: ColumnState[]) => void;
}

const useReconciliationFilterStore = create<ReconciliationFilterState>()(
  persist(
    (set) => ({
      statusFilter: [],
      setStatusFilter: (status) => set({ statusFilter: status }),
      preparerFilter: [],
      setPreparerFilter: (preparer) => set({ preparerFilter: preparer }),
      selectedEntityId: '',
      setSelectedEntityId: (entityId) => set({ selectedEntityId: entityId }),
      columnState: [],
      setColumnState: (order) => set({ columnState: order }),
    }),
    {
      name: 'Reconciliation-filter-storage',
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({
        statusFilter: state.statusFilter,
        preparerFilter: state.preparerFilter,
        selectedEntityId: state.selectedEntityId,
        columnState: state.columnState,
      }),
    }
  )
);

export { useReconciliationFilterStore };
